import {Component, OnInit, OnDestroy} from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit, OnDestroy {

  constructor() { }

  ngOnInit() {
    $('.subHeader').addClass('subContactBig');
    $('.aboutLink').addClass('activeLink');
    $('.aboutLink a').css('color', 'white');
    $('.headline h1').text('ABOUT US');
  }

  ngOnDestroy(){
    $('.subHeader').removeClass('subContactBig');
    $('.aboutLink').removeClass('activeLink');
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/about us/about-us.component.ts